/*
This source is part of the Akeria  and is
copyrighted by Uniphore system software limited.

All rights reserved.  No part of this work may be reproduced, stored in a
retrieval system, adopted or transmitted in any form or by any means,
electronic, mechanical, photographic, graphic, optic recording or otherwise,
translated in any language or computer language, without the prior written
permission of  Uniphore system software limited.

Uniphore system software limited.
Vaishnavi Silicon Terrace, B- Block, 
3rd & 4th floor, Hosur Rd, 
Adugodi, Bengaluru, Karnataka 560095

India

Copyright 2019 Uniphore system software limited.

Modification History

Date          Version                    Author                            Description
----------   -----------          --------------- ----------------         ------------------------
01 07 2018    1                     Professional service Initial version     
05-12-2019    1.1                    Pappuraj                              Date picker added 
*/

import { Component, OnInit } from '@angular/core';
import { Platform, NavController, MenuController } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as moment from 'moment';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-emailchat',
  templateUrl: './emailchat.page.html',
  styleUrls: ['./emailchat.page.scss'],
})
export class EmailchatPage implements OnInit {

  headingtitle: any;
  emailID: any;
  langcontext: any;
  Fromdate: any;
  tilldate: any;
  Today: any;
  date: any;
  emailchatForm: any;
  formsubmitted: any;
  mindte: any;
  maxdte: any;
  constructor(public platform: Platform,public _DomSanitizer: DomSanitizer, public menuCtrl: MenuController, public actionVal: ActionlistenService, public navCtrl: NavController,public formBuilder: FormBuilder, public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService, public api: RestapiService) {
    this.emailID = "";
    this.date = new Date();
    this.Today = new Date().toISOString();

    this.emailchatForm = formBuilder.group({
      emailId: ['', Validators.compose([
        Validators.required])],
      fromdata: ['', Validators.required],
      tilldate: ['', Validators.required],
    });

    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['email_chat'];
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].email_chat;
    }
    this.headingtitle = this.langcontext.heading.text;
    this.getEmailData();
  }

  ionViewWillEnter () {
    this.menuCtrl.swipeEnable(false);
  }

  ngOnInit() {
  }

  showDatepicker(flg: any){
    if(flg == 'from'){
      if (this.Fromdate == undefined || this.Fromdate == null || this.Fromdate == "") {

        let fulldate = new Date();
        let mdte = new Date();
        this.cmndef.showdatePicker(fulldate, "", mdte).then(data => {
          this.Fromdate = data;
          console.log("first", this.Fromdate)
        },err=>{
          console.log(err);
        })
      }else{
        let fromsplit = this.Fromdate;
        let split = fromsplit.split("/");
        let sdate = split[1] + "/" + split[0] + "/" + split[2]
        var d = new Date(sdate);
        let mdte = new Date();
        this.cmndef.showdatePicker(d, "", mdte).then(data => {
          this.Fromdate = data;
          console.log("sec", this.Fromdate)
        }, err => {
          console.log(err);
        });
      }
    }else{
      if (this.tilldate == undefined || this.tilldate == null || this.tilldate == "") {
        let fromsplit = this.Fromdate;
        let minsplit = fromsplit.split("/");
        let mdate = minsplit[1] + "/" + minsplit[0] + "/" + minsplit[2]
        let minDate = new Date(mdate);
        let seldte = new Date(mdate);
        let maxdte = new Date();
        this.cmndef.showdatePicker(seldte, minDate, maxdte).then(data => {
          this.tilldate = data;
          console.log("first", this.tilldate);
        },err=>{
          console.log(err);
        })
      }else{
        let tosplit = this.tilldate;
        let split = tosplit.split("/");
        let sdate = split[1] + "/" + split[0] + "/" + split[2]
        var d = new Date(sdate);
        let minsplit = this.Fromdate.split("/");
        let mdate = minsplit[1] + "/" + minsplit[0] + "/" + minsplit[2]
        let minDate = new Date(mdate);
        let maxdte = new Date();
        this.cmndef.showdatePicker(d, minDate, maxdte).then(data => {
          this.tilldate = data;
          console.log("sec", this.tilldate)
        }, err => {
          console.log(err);
        });
      }
    }

  }

  async getEmailData() {
    let profile: any;
    let req: any;
    let res: any;
    await this.cmndef.loaderstart();
    req = {
      "mobileNo": localStorage.user,
      "requestType": "getProfileData",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }

    await this.api.postapi("updateDetails", req).then(async data => {
      res = data;
      if(res.emailID == undefined || res.emailID == ""){
        await this.cmndef.loaderend();
        this.cmndef.showConfirmAlert("",this.langcontext.emptyemail.label,"emailupdate",this.langcontext.emptyemail.yes,this.langcontext.emptyemail.no);
      }else{
        await this.cmndef.loaderend();
        this.emailID = res.emailID;
      } 

     }, async err => {
      console.log(err);
      await this.cmndef.loaderend();
    });
  }

  updatedetails() {
    let fdate: any;
    let tdate: any;
    console.log(this.Fromdate);
    console.log(this.tilldate);
    if (this.cmndecl.cordovaSupport) {
      fdate = this.Fromdate;
      tdate = this.tilldate
    }

    else {
      fdate = moment(this.Fromdate).format('DD/MM/YYYY');
      tdate = moment(this.tilldate).format('DD/MM/YYYY');
    }

    let req: any;
    let res: any;
    if (this.emailchatForm.valid) {
      req = {
        emialId: this.emailID,
        startDate: fdate,
        endDate: tdate,
        userChatSessionId: localStorage.userChatSessionId,
        userSessionID: localStorage.userSessionID
      }
      console.log(req); 
      this.api.postapi("emailChat",req).then(data=>{
        res = data;
        this.cmndecl.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage="/va/chat";
        this.navCtrl.navigateRoot("/va/chat");
      },err=>{
        console.log(err);
      })
    }

  }

  changedate() {
    this.mindte = new Date(this.Fromdate).toISOString();
    this.maxdte = new Date().toISOString();
 
  }

  changetodate() {
    console.log("change date for non cordova")
    console.log(this.tilldate);
  
  }


}
